import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {BillingRunDto} from "./billing-run.dto";
import {CustomerCreditDto} from "./customer-credit.dto";
import {CustomerPaymentPlannedDto} from "./customer-payment-planned.dto";

export class CustomerCreditAllocationDto extends DtoDetail{

    public billingRunDto? : BillingRunDto;
    public billingRunDtoId : number;
    public billingRunDtoName : string;
    public customerDtoId : number;
    public customerDtoName : string;
    public customerCreditDto? : CustomerCreditDto;
    public customerCreditDtoId : number;
    public customerCreditDtoName : string;
    public plannedPaymentDto? : CustomerPaymentPlannedDto;
    public plannedPaymentDtoId : number;
    public plannedPaymentDtoName : string;
    public allocatedAmount: number;
    public currency: string;

}